import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function AuthCallback() {
  const navigate = useNavigate()
  const [error, setError] = useState(null)

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Exchange the auth code for a session
        const { data: { session }, error: sessionError } = await supabase.auth.getSession()
        
        if (sessionError) throw sessionError
        
        if (session?.user) {
          // Check if user has an organization
          const { data: profile } = await supabase
            .from('users')
            .select('org_id')
            .eq('id', session.user.id)
            .single()

          if (profile?.org_id) {
            navigate('/dashboard', { replace: true })
          } else {
            // Check if this is a new user (created within last 5 minutes)
            const createdAt = new Date(session.user.created_at)
            const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000)
            const isNewUser = createdAt > fiveMinutesAgo
            
            // Only new users go to onboarding; existing users go to home
            navigate(isNewUser ? '/onboarding' : '/home', { replace: true })
          }
        } else {
          navigate('/login', { replace: true })
        }
      } catch (err) {
        console.error('Auth callback error:', err)
        setError(err.message)
      }
    }

    handleAuthCallback()
  }, [navigate])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-bold text-red-600 mb-2">Authentication Failed</h2>
          <p className="text-gray-600">{error}</p>
          <button
            onClick={() => navigate('/login')}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg"
          >
            Back to Login
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Completing sign in...</p>
      </div>
    </div>
  )
}
